var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconWeb = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "IconWeb",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.9 28.2",
  style: {
    enableBackground: "new 0 0 45.9 28.2"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0w{fill:none;stroke:#6FC9D1;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1w{fill:#6FC9D1;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0w",
  d: "M42.3,1H23l0,0H3.6C3.6,1,1,1.3,1,3.4v10.4V14v10.4c0,2.2,2.6,2.4,2.6,2.4H23l0,0h19.3c0,0,2.6-0.3,2.6-2.4V14 v-0.1V3.4C44.9,1.3,42.3,1,42.3,1z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1w",
  d: "M5.8,10.2h0.9l1.5,6c0.2,0.9,0.4,1.6,0.6,2.5h0.1c0.2-0.8,0.4-1.6,0.6-2.5l1.5-5.8h1l1.5,5.8 c0.2,0.9,0.4,1.6,0.6,2.5h0.1c0.2-0.8,0.4-1.6,0.6-2.5l1.5-6H17l-2.3,9.3h-1.1L12,13.9c-0.2-0.8-0.4-1.7-0.6-2.7h-0.1 c-0.2,1-0.4,1.9-0.6,2.7l-1.4,5.6H8.2L5.8,10.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1w",
  d: "M18.6,14.8c0-3,2.2-4.9,4.6-4.9c2.5,0,4.1,1.6,4.1,4.3c0,0.2,0,0.5,0,0.7h-8.3v-0.7H27l-0.4,0.3 c0-2.6-1.4-3.9-3.3-3.9c-1.9,0-3.8,1.5-3.8,4.1c0,2.7,1.9,4.1,4.1,4.1c1.3,0,2.2-0.4,3.1-1l0.4,0.6c-0.8,0.5-1.9,1.1-3.5,1.1 C20.9,19.7,18.6,17.9,18.6,14.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st1w",
  d: "M31.6,18.4L31.6,18.4l-0.1,1h-0.7V5.6h0.9v4l0,2h0c0.9-1,2.3-1.6,3.5-1.6c2.6,0,3.9,1.9,3.9,4.7 c0,3.1-2,5-4.3,5C33.8,19.7,32.5,19.2,31.6,18.4z M38.1,14.7c0-2.3-0.9-4-3.2-4c-1,0-2.2,0.5-3.3,1.7v5.1c1.1,1,2.3,1.4,3,1.4 C36.6,18.9,38.1,17.2,38.1,14.7z"
})))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconWeb, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconWeb.92143359.svg";
export { ForwardRef as ReactComponent };